import { makeStyles } from "@material-ui/core/styles";
import { Box, Grid, List, ListSubheader, Typography, Tooltip } from "@material-ui/core";
import { i18n } from "../../translate/i18n";
import { useHistory, useParams } from "react-router-dom";
import api from "../../services/api";
import { toast } from "react-toastify";
import toastError from "../../errors/toastError";
import TicketsListSkeleton from "../TicketsListSkeleton";
import ContactListItem from "../ContactListItem";
import TicketListItem from "../TicketListItem";
import SelectAction from "../SelectAction/SelectAction";
import GeneralActions from "../../helpers/GeneralActions";
import { useEffect, useContext, useState } from "react";
import { AuthContext } from "../../context/Auth/AuthContext";
import BatchConclusionMessages from "../BatchConclusionMessages";
import BatchTagModal from "../BatchTagModal";
import BatchTransferModal from "../Ticket/batchTransferModal";

import CheckBoxIcon from '@material-ui/icons/CheckBox';
import SpeakerNotesIcon from '@material-ui/icons/SpeakerNotes';
import FilterListTwoToneIcon from '@mui/icons-material/FilterList';
import SortByAlphaIcon from '@material-ui/icons/SortByAlpha';
import KeyboardDoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown';

const useStyles = makeStyles((theme) => ({
    ticketsListHeader: {
        color: "rgb(67, 83, 105)",
        zIndex: 2,
        backgroundColor: theme.palette.background.default,
        borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
    },
    ticketsCount: {
        fontWeight: "normal",
        color: "rgb(104, 121, 146)",
        marginLeft: "8px",
        fontSize: "14px",
    },
    actionIcons: {
        cursor: 'pointer',
        marginLeft: '5px',
        height: '20px',
        [theme.breakpoints.down('960')]: {
            marginLeft: '10px',
        }
    },
    contactTitle: {
        fontSize: '1.1rem',
        margin: '10px 0 10px 10px!important',
        color: 'rgba(0, 0, 0, 0.54)!important',
        fontWeight: '700!important'
    },
}));

const TicketManagementList = ({ contacts, tickets, selectedTickets, handleSelect, handleSelectAll, unSelectAll, loading, pressed, order, handlePressed, handleOrder, totalCount }) => {

    const classes = useStyles();
    const history = useHistory();
    const { user } = useContext(AuthContext);
    const [conclusionModalOpen, setConclusionModalOpen] = useState(false);
    const [tagModalOpen, setTagModalOpen] = useState(false);
    const [transferModalOpen, setTransferModalOpen] = useState(false);
    const { ticketId, contactId } = useParams();

	const showTagModalOpen = () => {
		setTagModalOpen(true);
	};

	const hideTagModalOpen = () => {
		setTagModalOpen(false);
        unSelectAll();
	};

    const showBatchConclusionMessages = () => {
        setConclusionModalOpen(true);
    };

    const hideBatchConclusionMessages = () => {
        setConclusionModalOpen(false);
        unSelectAll();
    }

    // manipulando o modal de transferencia em massa
    const showBatchTransferModal = () => {
        setTransferModalOpen(true);
    }

    const hideBatchTransferModal = () => {
        setTransferModalOpen(false);
    }

    return (
        <>
            <List
                id="ticketManagementList"
                key="ticketManagementList"
            >
                <ListSubheader
                    style={{ height: '35px', zIndex: 5, top: ticketId && ticketId != '' && ticketId != 'undefined' ? '50px' : '0' }}
                    className={classes.ticketsListHeader}
                >
                    <Box component="div">
                        {i18n.t("ticketManagement.list.tickets")}
                        <Typography
                            component="span"
                            className={classes.ticketsCount}
                        >
                            {`${tickets.length}/${totalCount}`}
                        </Typography>
                    </Box>

                    <Grid
                        style={{
                            display: "block"
                        }}
                    >
                        {
                            Array.isArray(selectedTickets) && selectedTickets.length > 0
                            &&
                            <SelectAction
                                status={undefined}
                                selectedTickets={selectedTickets}
                                onOpen={() => GeneralActions("open", { userId: user.id, selectedTickets }, () => { unSelectAll(); toast.success(i18n.t("ticketManagement.messages.successfullyUpdated")); history.push("/ticketManagement"); })}
                                onTransferToAwait={() => GeneralActions("pending", { selectedTickets }, () => { unSelectAll(); toast.success(i18n.t("ticketManagement.messages.successfullyUpdated")); history.push("/ticketManagement"); })}
                                onConcludeTicket={() => showBatchConclusionMessages()}
                                onTagModal={() => showTagModalOpen()}
                                onRemoveTags={() => GeneralActions("removeTags", { selectedTickets }, () => { unSelectAll(); toast.success(i18n.t("ticketManagement.messages.successfullyUpdated")); history.push("/ticketManagement"); })}
                                onUnread={() => GeneralActions("setUnread", { selectedTickets }, () => { unSelectAll(); toast.success(i18n.t("ticketManagement.messages.successfullyUpdated")); history.push("/ticketManagement"); })}
                                onTransfer={() => showBatchTransferModal()}
                            />
                        }

                        <Tooltip
                            title={i18n.t("ticketManagement.list.selectAllTickets")}
                        >
                            <CheckBoxIcon
                                className={classes.actionIcons}
                                margin="dense"
                                variant="outlined"
                                color="action"
                                onClick={handleSelectAll}
                                style={{
                                    color: Array.isArray(selectedTickets) && selectedTickets.length == tickets.length ? '#0b708c' : 'rgb(67, 83, 105)'
                                }}
                            />
                        </Tooltip>

                        <Tooltip
                            title={i18n.t("ticketManagement.list.unanswered")}
                        >
                            <SpeakerNotesIcon
                                className={classes.actionIcons}
                                onClick={() => handlePressed()}
                                style={{
                                    color: pressed == true ? '#0b708c' : 'rgb(67, 83, 105)'
                                }}
                            >
                                <FilterListTwoToneIcon
                                    style={{
                                        cursor: 'pointer',
                                        marginLeft: '2px',
                                        height: '20px',
                                        width: '20px'
                                    }}
                                    margin="dense"
                                    variant="outlined"
                                    color="action"
                                />
                            </SpeakerNotesIcon>
                        </Tooltip>

                        <Tooltip
                            title={i18n.t("ticketManagement.list.orderByDate")}
                        >
                            <SortByAlphaIcon
                                className={classes.actionIcons}
                                onClick={() => handleOrder()}
                                style={{
                                    color: order == "DESC" ? '#0b708c' : 'rgb(67, 83, 105)'
                                }}
                            >
                                <KeyboardDoubleArrowDownIcon
                                    style={{ cursor: 'pointer', marginLeft: '2px', height: '20px' }}
                                    margin="dense"
                                    variant="outlined"
                                    color="action"
                                />
                            </SortByAlphaIcon>
                        </Tooltip>
                    </Grid>
                </ListSubheader>
                {
                    Array.isArray(contacts) && contacts.length > 0 &&
                    <Box>
                        <Typography className={classes.contactTitle}>{i18n.t("ticketManagement.list.contacts")}</Typography>
                        {contacts.map(contact => {
                            return (<ContactListItem contact={contact} />)
                        })}
                        <Typography className={classes.contactTitle}>{i18n.t("ticketManagement.list.tickets")}</Typography>
                    </Box>
                }
                {
                    Array.isArray(tickets) && tickets.length > 0 &&
                    tickets.map((ticket, index) => (
                        <TicketListItem
                            ticket={ticket}
                            key={ticket.id}
                            index={index}
                            onClick={e => {
                                e.stopPropagation();
                                e.preventDefault();
                                handleSelect(ticket.id);
                            }}
                            checked={Array.isArray(selectedTickets) && selectedTickets.includes(+ticket.id)}
                            hiddenCheckboxOption={contacts.length > 0 ? true : false}
                            searchingByParam={true}
                            byTicketManagement={true}
                        />
                    ))
                }

                {
                    loading
                    &&
                    <TicketsListSkeleton />
                }
            </List>
            <BatchConclusionMessages
                open={conclusionModalOpen}
                handleClose={hideBatchConclusionMessages}
                onConcludeTicket={GeneralActions}
                selectedTickets={selectedTickets}
                onConcludeClean={() => {
                    toast.success(i18n.t("ticketManagement.messages.successfullyUpdated"));
                    hideBatchConclusionMessages();
                    unSelectAll();
                    history.push("/ticketManagement");
                }}
            />
            <BatchTagModal
                open={tagModalOpen}
                onClose={hideTagModalOpen}
                onSave={GeneralActions}
                selectedTickets={selectedTickets}
                byTicketManagement={true}
            />
            <BatchTransferModal
                tcktIds={selectedTickets}
                onClose={hideBatchTransferModal}
                onSuccess={() => {
                    unSelectAll();
                    toast.success('Atualizado com sucesso!');
                }}
                open={transferModalOpen == true && selectedTickets.length > 0 ? true : false}
            />
        </>
    );
};

export default TicketManagementList;